module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external "vegaEmbed"
// module id = 2
// module chunks = 0